import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../app/Api/ApiSlice";
import { toast } from "react-toastify";
import moment from "moment";
import Loader from "../components/Loader";

const UserOrders = () => {
    const [userOrders, setUserOrders] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const { name } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        const getOrders = async () => {
            try {
                setIsLoading(true);
                const response = await api.get(`/stores/orders`);
                console.log(response)
                setUserOrders(response.data || []);
            } catch (error) {
                toast.error(error.response?.data?.message || "Error fetching orders");
            } finally {
                setIsLoading(false);
            }
        };

        getOrders();
    }, [name]);

    return (
        <div className="store-user-carts-list">
            <h5>Your orders in {name}</h5>

            {!isLoading && userOrders.length === 0 && (
                <p className="not-found-msg">
                    You have not created any order
                </p>
            )}

            {!isLoading && userOrders.length > 0 && (
                <table>
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>order No</th>
                            <th>Description</th>
                            <th>Items</th>
                            <th>Total Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {userOrders.map(order => (
                            <tr
                                key={order._id}
                                onClick={() => navigate(`/b/${name}/orders/${order._id}`)}
                                style={{ cursor: "pointer" }}
                            >
                                <td>{moment(order.createdAt).format("DD MM YYYY")}</td>
                                <td>{order.orderNo}</td>
                                <td>{order.store.name}</td>
                                <td>{order.description || "No description"}</td>
                                <td>{order.items.length}</td>
                                <td>{order.total}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
              {isLoading && <Loader />}
        </div>
    );
};

export default UserOrders;
